export default __webpack_public_path__ + "static/media/Diamond_red.7ccd393c.png";